import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

export default function AdminSeoPageList() {
  const [pages, setPages] = useState([]);
  const [error, setError] = useState("");

  async function load() {
    try { setPages(await api("/api/admin/seo-pages")); }
    catch (err) { setError(err.message); }
  }

  useEffect(() => { load(); }, []);

  async function remove(id) {
    if (!window.confirm("Delete this SEO record?")) return;
    try { await api(`/api/admin/seo-pages/${id}`, { method: "DELETE" }); load(); }
    catch (err) { alert(err.message); }
  }

  return (
    <AdminLayout
      title="SEO Manager"
      subtitle="Control page titles, descriptions, Open Graph data, canonical URLs and search indexing rules."
      actions={<Link to="/adxm/seo/create" className="rounded-xl bg-emerald-700 px-4 py-3 text-sm font-bold text-white">Add SEO Page</Link>}
    >
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      <div className="overflow-x-auto rounded-3xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="p-4">Path</th><th className="p-4">Title</th><th className="p-4">Robots</th><th className="p-4">Status</th><th className="p-4">Actions</th></tr>
          </thead>
          <tbody>
            {pages.map((item) => (
              <tr key={item.id} className="border-t border-slate-100">
                <td className="p-4 font-black text-emerald-700">{item.page_path}</td>
                <td className="p-4"><div className="font-bold text-slate-900">{item.title}</div><div className="mt-1 line-clamp-1 text-xs text-slate-500">{item.description}</div></td>
                <td className="p-4">{item.robots}</td>
                <td className="p-4"><span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold capitalize">{item.status}</span></td>
                <td className="p-4">
                  <div className="flex gap-3">
                    <Link className="font-bold text-blue-700" to={`/adxm/seo/edit/${item.id}`}>Edit</Link>
                    <button className="font-bold text-red-700" onClick={() => remove(item.id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {pages.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-slate-500">No SEO pages found.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
